import Swiper from "swiper";
import { Navigation, EffectFade } from "swiper/modules";

new Swiper(".amenities__images .swiper", {
	modules: [Navigation, EffectFade],
	effect: "fade",
	speed: 1 * 1000,
	// Navigation arrows
	navigation: {
		nextEl: '.amenities__swiper-button--next',
		prevEl: '.amenities__swiper-button--prev',
	},
});
